export default {"src":"/_next/static/media/WhoWeAre_015A.0179488c.JPG","height":690,"width":1920};